import { SET_HAS_VEHICLE } from '../actions/hasVehicleDataActions';

let initialState = false;

const hasVehicleDataReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_HAS_VEHICLE:
            return action.payload.value
        default:
            return state;
    }
}

export default hasVehicleDataReducer;